import type { TransactionRecord } from '@/types/Transaction'
import type { Person } from '@/types/Person'
import type { Organization } from '@/types/Organization'

export class TransactionPartyModel {
  constructor(
    private tx: TransactionRecord,
    private person?: Person,
    private organization?: Organization,
  ) {}

  get name(): string {
    const orgName = this.organization?.name || this.tx.organizationSnapshot?.name
    const firstName = this.person?.firstName || this.tx.personSnapshot?.firstName
    const fullPersonName =
      [this.person?.firstName, this.person?.middleName, this.person?.lastName]
        .filter(Boolean)
        .join(' ') ||
      [
        this.tx.personSnapshot?.firstName,
        this.tx.personSnapshot?.middleName,
        this.tx.personSnapshot?.lastName,
      ]
        .filter(Boolean)
        .join(' ')

    if (firstName && orgName) {
      return `${firstName} - ${orgName}`
    } else if (fullPersonName) {
      return fullPersonName
    } else if (orgName) {
      return orgName
    } else {
      return 'Unknown'
    }
  }

  get email() {
    if (this.isCompany) {
      return this.organization?.email || this.tx.organizationSnapshot?.email || null
    }
    return this.person?.email || this.tx.personSnapshot?.email || null
  }

  get phone() {
    if (this.isCompany) {
      return this.organization?.phone || this.tx.organizationSnapshot?.phone || null
    }
    return this.person?.phone || this.tx.personSnapshot?.phone || null
  }

  get address(): string {
    const fields = [
      this.person?.streetAddress || this.tx.personSnapshot?.streetAddress,
      this.person?.city || this.tx.personSnapshot?.city,
      this.person?.state || this.tx.personSnapshot?.state,
      this.person?.postalCode || this.tx.personSnapshot?.postalCode,
      this.person?.country || this.tx.personSnapshot?.country,
    ]
    return fields.filter(Boolean).join(', ')
  }

  get idInfo(): { number: string; image: string } {
    return {
      number: this.person?.idNumber || this.tx.personSnapshot?.idNumber || 'N/A',
      image: this.person?.photoIdUrl || this.tx.personSnapshot?.photoIdUrl || '',
    }
  }

  get isCompany(): boolean {
    return !!(this.organization?.name || this.tx.organizationSnapshot?.name)
  }
}
